import axios from 'axios'
import Swal from 'sweetalert2'
import store from '@/store'
import Client from '@/apis/liff/Chatroom'
import { processLiffState } from './helpers'
import VConsole from 'vconsole';

const PATH_PATTERN = '%s/liff/chatrooms%s'
const ROUTE_PORTAL = 'LiffChatroomPortal'
const ROUTE_INDEX = 'LiffChatroomIndex'

function tokenProvider () {
  return store.getters['liffChatroom/token']
}

async function liffInitializer () {
  await store.dispatch('liffChatroom/removeToken')
  await store.dispatch('liffChatroom/init')
}

export default async function liffChatroom({ next, to }) {
  const orgCode = to.params.orgCode
  const baseURL = `${process.env.VUE_APP_API_BASE_URL}/${orgCode}/liff/chatrooms`

  console.debug(`navigated to: ${to.fullPath}`)

  store.commit('liffChatroom/SET_ORG_CODE', orgCode)
  store.commit('liffChatroom/SET_API_BASE_URL', baseURL)

  if (to.query['liff.state']) {
    return processLiffState({ to, next, orgCode, pathPattern: PATH_PATTERN })
  }

  if (to.query['vconsole']) {
    new VConsole({ theme: 'dark' });
  }

  if (to.name === ROUTE_PORTAL) {
    return next({ name: ROUTE_INDEX, params: { orgCode } })
  }

  if (!Client.instance) {
    await Client.init({ axios, baseURL, tokenProvider, liffInitializer })
  }

  if (to.query['as_staff'] == true || to.query['as_staff'] === '1' || to.query['as_staff'] === 'true') {
    // 入口帶 query：設定身份並寫入 session cookie
    await store.dispatch('liffChatroom/setAsStaff', true);
  } else {
    // 內部導航或重新載入沒有 query：由 cookie 還原 staff 身份
    await store.dispatch('liffChatroom/hydrateAsStaff');
  }

  try {
    await store.dispatch('liffChatroom/fetchUser')
  } catch (error) {
    const message = error.message || '發生錯誤，請稍後再試'
    await Swal.fire({
      type: 'error',
      title: message,
      showCloseButton: false,
      showConfirmButton: false,
      allowOutsideClick: false,
    })
    return
  }

  return next()
}
